"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=royalty.js.map